import { generateTrackingId, getLocalStorage } from "./utilities";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Constants

const VISITOR_ID_STORAGE_KEY = "dewey--analytics--visitorId";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Visitor ID

let visitorId: string | null | undefined = undefined;

export function getVisitorId(): string {
  // Check if we already have a visitor ID in memory
  if (visitorId) return visitorId;

  // If we don't have a visitor ID in memory, we need to check LocalStorage
  const localStorage = getLocalStorage();
  if (localStorage) {
    // If we have access to LocalStorage, try to get the visitor ID
    visitorId = localStorage.getItem(VISITOR_ID_STORAGE_KEY);

    if (!visitorId) {
      // If we don't have a saved visitor ID, generate and save a new one
      visitorId = generateTrackingId();
      localStorage.setItem(VISITOR_ID_STORAGE_KEY, visitorId);
    }
  } else {
    // If we don't have access to LocalStorage, generate a new visitor ID
    visitorId = generateTrackingId();
  }

  return visitorId;
}
